import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, map, tap, throwError } from 'rxjs';
import { environment } from 'src/environments/environment';
import { PermissionsList, UpdatePermissionsPayload } from './operatori.interface';

@Injectable({
    providedIn: 'root',
})
export class OperatoriService {
    private token!: string;
    private httpOptions: any;

    private basePath = environment.interop.basePath;

    private getPermisiuniListUrl =
        this.basePath +
        environment.interop.deps.nomenclatoare.operatori
            .getOperatorPermisiuniList;

    private updateOperatorUrl =
        this.basePath +
        environment.interop.deps.nomenclatoare.operatori.updateOperatorPermisiuni;

    private getOperatorFunctieUrl = this.basePath + environment.interop.deps.nomenclatoare.operatori.getOperatorFunctie;
    private updateOperatorFunctieUrl = this.basePath + environment.interop.deps.nomenclatoare.operatori.updateOperatorFunctie;

    constructor(private http: HttpClient) { }

    permisiuniList(id: number) {
        return this.http.get<{ errors: boolean; data: PermissionsList; status_code: number }>(
            this.getPermisiuniListUrl + id,
        );
    }

    updateOperator(id: number, data: UpdatePermissionsPayload) {
        return this.http.post(this.updateOperatorUrl + id, data);
    }

    getOperatorFunctie(id: number) {
        return this.http.get(this.getOperatorFunctieUrl + id);
    }

    updateOperatorFunctie(user_id: number, data: { functie_id: number }) {
        return this.http.put(this.updateOperatorFunctieUrl + user_id, data);
    }

    setToken(token: string) {
        this.token = token;
        this.httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                Accept: 'application/json',
                Authorization: `Bearer ${this.token}`,
            }),
        };
    }
}
